import { PrivacySource, PrivacyStatus } from '@inditex/coanalytjs';
import { CookiesConsent } from './cookies-consent';
import { parseActiveGroups } from './onetrust-active-groups';

/**
 * OneTrust group IDs mapped to coanalyt privacy scopes.
 * C0001 = Strictly Necessary (technical)
 * C0002 = Performance / Analytics
 * C0003 = Functional / Personalization
 * C0004 = Targeting / Marketing
 */
const ONETRUST_GROUPS = {
	TECHNICAL: 'C0001',
	ANALYTICS: 'C0002',
	FUNCTIONAL: 'C0003',
	ADVERTISING: 'C0004',
} as const;

const isGroupActive = (activeGroups: string[], group: string): boolean =>
	activeGroups.includes(group);

const createPrivacyConsent = () => {
	const consent = CookiesConsent.getInstance();
	const rawActiveGroups = window.OnetrustActiveGroups ?? '';
	const activeGroupsList = parseActiveGroups(rawActiveGroups).split(',').filter(Boolean);
	
	const hasAnalyticsConsent = isGroupActive(activeGroupsList, ONETRUST_GROUPS.ANALYTICS);

	const privacyConsent  = {
		status: hasAnalyticsConsent ? PrivacyStatus.GRANTED : PrivacyStatus.DENIED,
		scopes: {
			necessary: isGroupActive(activeGroupsList, ONETRUST_GROUPS.TECHNICAL),
			analytics: isGroupActive(activeGroupsList, ONETRUST_GROUPS.ANALYTICS),
			personalization: isGroupActive(activeGroupsList, ONETRUST_GROUPS.FUNCTIONAL),
			marketing: isGroupActive(activeGroupsList, ONETRUST_GROUPS.ADVERTISING),
			social: false,
		},
		source: PrivacySource.CMP,
		cmp: 'onetrust' as const,
		timestamp: consent.getConsentedDate() || new Date().toISOString(),
		raw: {
			onetrust_consent_categories: rawActiveGroups?.replace(/^,|,$/g, ''),
		},
	};
	return privacyConsent;
	
};

export default createPrivacyConsent;
